/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostawsauthaccountidPostBody
 */
export interface JumboPostawsauthaccountidPostBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostawsauthaccountidPostBody
     */
    userAccountID: string;
}

/**
 * Check if a given object implements the JumboPostawsauthaccountidPostBody interface.
 */
export function instanceOfJumboPostawsauthaccountidPostBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userAccountID" in value;

    return isInstance;
}

export function JumboPostawsauthaccountidPostBodyFromJSON(json: any): JumboPostawsauthaccountidPostBody {
    return JumboPostawsauthaccountidPostBodyFromJSONTyped(json, false);
}

export function JumboPostawsauthaccountidPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostawsauthaccountidPostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAccountID': json['userAccountID'],
    };
}

export function JumboPostawsauthaccountidPostBodyToJSON(value?: JumboPostawsauthaccountidPostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAccountID': value.userAccountID,
    };
}

